module.exports = __webpack_public_path__ + "static/media/uploadIcon.4e534149.svg";